import { useEffect } from "react";
import { useParams } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/harvest/h`;

/**
 * Landing target for the QR codes printed on Harvest Plan cards (ohcbenefits.com/h/:slug).
 * The browser follows the backend redirect, which logs the scan and sends the visitor to the
 * Harvest Plan page. Unknown slugs still land somewhere sensible.
 */
export default function HarvestScan() {
  const { slug } = useParams();

  useEffect(() => {
    window.location.replace(`${API}/${encodeURIComponent(slug || "")}`);
  }, [slug]);

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-forest px-6"
      data-testid="harvest-scan-page"
    >
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-cream/60">
        Opening your Harvest Plan…
      </p>
    </div>
  );
}
